import React from "react";
import styled from "styled-components";

const Container = styled.div`
  font-family: "Malgun Gothic", Arial, sans-serif;
  line-height: 1.6;
  margin: 0;
  padding: 0;
  color: #333;
  background-color: #f5f5f5;

  /* A4 표지 페이지 스타일 */
  .cover-page {
    margin: 0 auto;
    height: 29.7cm;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    page-break-after: always;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    box-sizing: border-box;
  }

  .cover-decorative-top {
    width: 100%;
    height: 10px;
    background: linear-gradient(
      to right,
      #1e3a5f,
      #4472a8,
      #7aa3d1,
      #b8d4f0,
      #e8f2ff,
      #e8f2ff,
      #b8d4f0,
      #7aa3d1,
      #4472a8,
      #1e3a5f
    );
    margin: 0;
  }

  .cover-decorative-bottom {
    width: 100%;
    height: 10px;
    background: linear-gradient(
      to right,
      #1e3a5f,
      #4472a8,
      #7aa3d1,
      #b8d4f0,
      #e8f2ff,
      #e8f2ff,
      #b8d4f0,
      #7aa3d1,
      #4472a8,
      #1e3a5f
    );
    margin: 0;
  }

  .cover-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    text-align: center;
  }

  .cover-title {
    font-size: 42px;
    font-weight: bold;
    color: #1e3a5f;
    line-height: 1.4;
    letter-spacing: -1px;
    margin: 20px 0;
  }

  .cover-date {
    font-size: 36px;
    font-weight: normal;
    color: #333;
    margin: 2cm 0;
  }

  .cover-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2cm;
  }

  .cover-logo {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-weight: bold;
    color: #1e3a5f;
  }

  .cover-logo-symbol {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  .cover-institution {
    font-size: 20px;
    color: #333;
    text-align: right;
  }

  /* 목차 페이지 스타일 */
  .toc-page {
    max-width: 21cm;
    height: 29.7cm;
    margin: 0 auto;
    padding: 2cm 20px;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    page-break-before: always;
    page-break-after: always;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .toc-main-content {
    flex: 0 0 auto;
  }

  .toc-title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 2cm;
    letter-spacing: 2px;
  }

  .toc-content {
    font-size: 18px;
    line-height: 2.2;
  }

  .toc-item {
    display: flex;
    justify-content: space-between;
    margin: 25px 0;
    border-bottom: 1px dotted #ccc;
    padding-bottom: 8px;
  }

  .toc-item:last-child {
    border-bottom: none;
  }

  .toc-indent {
    padding-left: 30px;
  }

  .page-number {
    position: absolute;
    bottom: 2cm;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    color: #333;
  }

  .container {
    max-width: 21cm;
    margin: 0 auto;
    padding: 2cm 0px;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }
  .header {
    text-align: center;
    margin-bottom: 50px;
    border-top: 2px solid #354380;
    border-bottom: 2px solid #354380;
    padding: 20px 0;
    background: linear-gradient(to right, #354380, white, white, #354380);
  }
  .header h1 {
    color: #354380;
    font-size: 28px;
    font-weight: bold;
    margin: 0;
    padding: 10px 0;
  }
  .date {
    text-align: center;
    font-size: 24px;
    margin: 50px 0;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
  }
  .logo {
    width: 30%;
  }
  .institution {
    font-size: 20px;
    text-align: right;
    width: 60%;
  }
  .toc {
    margin: 30px 0;
  }
  .toc h2 {
    text-align: center;
    font-size: 24px;
  }
  .toc-item {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
  }
  .disclaimer {
    border: 1px solid #ccc;
    padding: 15px;
    margin: 20px 0;
  }
  .section {
    margin: 30px 0;
  }
  .section h2 {
    color: #354380;
    border-bottom: 1px solid #354380;
    padding-bottom: 5px;
  }
  .section h3 {
    color: #354380;
    margin-top: 25px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    word-break: keep-all;
    table-layout: fixed;
  }
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }
  th {
    background-color: #e8f4f8;
  }
  
  /* 첫 번째 테이블 - 전체 글씨 크기 작게 */
  .ref-table td,
  .ref-table th {
    font-size: 12px;
  }
  
  /* 세 번째 테이블 - 1,2,4번째 열만 글씨 크기 작게 */
  .main-table td:nth-child(1),
  .main-table td:nth-child(2),
  .main-table td:nth-child(4),
  .main-table th:nth-child(1),
  .main-table th:nth-child(2),
  .main-table th:nth-child(4) {
    font-size: 12px;
  }
  
  .green-bg {
    background-color: #e0f0e0;
  }
  .references {
    margin-top: 50px;
  }
  .ref-table th {
    background-color: #f0f0f0;
    font-weight: bold;
  }
  .ref-table td {
    vertical-align: top;
  }
  .blue-header th {
    height: 40px;
    background-color: #214478;
    color: white;
    font-weight: bold;
    text-align: center;
    z-index: 10;
  }
  .gray-header td {
    background-color: #f5f5f5;
    font-weight: bold;
    position: sticky;
    top: 0px; 
    z-index: 9;
  }
  .definition {
    margin: 10px 0;
  }
  .diseases-list {
    margin: 20px 0;
    line-height: 1.8;
  }
  .toc-disclaimer {
    flex: 0 0 auto;
    margin-top: auto;
  }
`;

const CCMM: React.FC = () => {
  return (
    <Container>
      <div className="cover-page">
        <div className="cover-content">
          <div className="cover-decorative-top"></div>
          <div className="cover-title">
            지역사회 노인을 위한
            <br />
            포괄적 약물검토 가이드
          </div>
          <div className="cover-decorative-bottom"></div>
          <div className="cover-date">2023. 02</div>
        </div>
        <div className="cover-footer">
          <div className="cover-logo">
            <span className="cover-logo-symbol">SNU PHARMACY</span>
          </div>
          <div className="cover-institution">
            서울대학교 약학대학
            <br />
            임상약학실
          </div>
        </div>
      </div>

      <div className="toc-page">
        <div className="toc-main-content">
          <div className="toc-title">목차</div>
          <div className="toc-content">
            <div className="toc-item">
              <span>I. 단계별 환자 중심 약물 검토</span>
              <span>3</span>
            </div>

            <div className="toc-item">
              <span>II. 지역사회 거주 노인을 위한 한국형 약물요법 검토 도구</span>
              <span>7</span>
            </div>

            <div className="toc-item">
              <span style={{ paddingLeft: "20px" }}>1. 개발 개요</span>
              <span>7</span>
            </div>

            <div className="toc-item">
              <span style={{ paddingLeft: "20px" }}>2. 도구의 구성</span>
              <span>9</span>
            </div>
          </div>
        </div>
        <div className="toc-disclaimer">
          <div className="disclaimer">
            <h3 style={{ margin: 0 }}>책임 면제 (Disclaimer)</h3>
            <p style={{ margin: 0 }}>
              본 지역사회 노인을 위한 포괄적 약물 검토 가이드는 지역사회 약국에서 환자의 안전한 약물
              사용을 위한 약물 검토 가이드를 제시하고 있습니다. 이는 지역사회 약국 약사의 약물 검토
              모델을 기반으로 하고 있으며, 약사의 약물 요법 평가 및 중재와 관련한 일반적인 사항을
              포함하고 있습니다. 따라서 본 가이드를 적용함에 있어 의사의 임상적 진단이 우선되어야
              하며 환자의 임상적 상황이 고려되어야 함을 밝힙니다.
            </p>

            <h3 style={{ marginBottom: 0 }}>감사 (Acknowledgement)</h3>
            <p style={{ margin: 0 }}>
              본 지역사회 노인을 위한 포괄적 약물 검토 가이드는 과학기술정보통신부 한국연구재단
              연구과제 중 하나인 "지역사회 및 요양원 거주 노인을 위한 한국형 약물요법 검토 도구 개발
              및 타당성 검증 연구 (과제번호: 370C-20220061)"에서 도출된 것입니다.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="section">
          <h2>I. 단계별 환자 중심 약물검토</h2>

          <table>
            <colgroup>
              <col style={{ width: "30%" }} />
              <col style={{ width: "70%" }} />
            </colgroup>
            <tr className="green-bg">
              <th colSpan={2}>[0단계] 약력 및 기초적인 환자 특성 확인</th>
            </tr>
            <tr>
              <td>약력 확인</td>
              <td>
                <ul>
                  <li>환자가 가져온 약/처방내역 확인</li>
                  <li>최근 중단/변경된 약, 처방에 있으나 복용하고 있지 않은 약 확인</li>
                  <li>필요시 [내가 먹는 약! 한눈에] 서비스 이용</li>
                  <li>상담을 통해서 일반의약품, 건강기능식품 확인</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>기초적인 환자 특성 확인</td>
              <td>
                <ul>
                  <li>연령, 성별, 흡연/음주 여부, 알레르기</li>
                  <li>기저질환</li>
                  <li>최근 입/퇴원 여부</li>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[1단계] 포괄적 약물검토의 목적 확인</th>
            </tr>
            <tr>
              <td>환자에게 현재 중요한 것은 무엇인가?</td>
              <td>
                <ul>
                  <li>약물치료의 목적 이해</li>
                  <li>환자의 현존하는 건강문제 관리</li>
                  <li>향후 건강문제의 예방</li>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[2단계] 필요성, 적응증 확인</th>
            </tr>
            <tr>
              <td>적응증이 명확한가?</td>
              <td>
                <ul>
                  <li>허가적응증과 현재 환자 질병상태와의 일치</li>
                  <li>적응증 부재(오프라벨 사용 고려)</li>
                  <li>
                    과거에 해당되었으나 더 이상 존재하지 않음
                    <br />
                    (예, 단기 복용 약물의 적응증(상태)이 해소되었는가?)
                    <ul>
                      <li>감기약, 항히스타민제, 진해제</li>
                      <li>진통제</li>
                      <li>소화기관용제(진경제, 위산분비억제제) 등</li>
                      <li>이뇨제</li>
                    </ul>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>불필요한 중복처방이 있는가?</td>
              <td>
                <ul>
                  <li>
                    빈번한 중복처방 계열
                    <ul>
                      <li>NSAIDs</li>
                      <li>Benzodiazepines</li>
                      <li>Antipsychotics</li>
                      <li>소화기관용제: 위산분비억제제, Prokinetics</li>
                      <li>항혈전제2종 중복(비의도적, 다른 진료과)</li>
                    </ul>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>치료기간이 적절한가?</td>
              <td>
                <ul>
                  <li>
                    허가 용량용법/가이드라인에서 치료기간 확인
                    <ul>
                      <li>항생제(치료목적 vs. 예방적)</li>
                      <li>PPI: 8주 이상</li>
                    </ul>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>적절 용량보다 높은 용량을 사용하는가?</td>
              <td>
                <ul>
                  <li>노인 최대용량 확인</li>
                  <li>적응증에 따른 용량 확인</li>
                  <ul>
                    <li>PPI의 경우 치료 용량/예방 또는 유지용량 확인</li>
                  </ul>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[3단계] 효과성 확인</th>
            </tr>
            <tr>
              <td>약물치료의 목적이 달성되었는가?</td>
              <td>
                <ul>
                  <li>약물치료의 목적 달성을 위한 약물 추가 또는 중단이 필요한지 확인</li>
                  <ul>
                    <li>
                      증상 조절이 잘 되고 있는가? (통증, 협심증, 파킨슨 증상, 감상선기능 증상 등)
                    </li>
                    <li>치료 개선(혈압, 혈당, 지질)</li>
                  </ul>
                </ul>
              </td>
            </tr>
            <tr>
              <td>치료 목적을 위한 용량, 용법이 적절한가?</td>
              <td>
                <ul>
                  <li>약물이 효과가 없으며, 표준 용량 이하로 사용되고 있는가?</li>
                  <li>투여시간이 적절한가? (약물-음식 상호작용)</li>
                  <ul>
                    <li>철분제, 칼슘제</li>
                    <li>Levodopa 제제</li>
                    <li>갑상선호르몬제</li>
                    <li>테트라사이클린계, 퀴놀론계 항생제</li>
                    <li>수면 또는 진정작용 약물</li>
                    <li>불면을 유발하는 약물</li>
                    <li>이뇨제 등</li>
                  </ul>
                  <li>상호작용을 고려할 때 증량이 필요한가?</li>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[4단계] 안전성 확인</th>
            </tr>
            <tr>
              <td>약물이상반응을 경험하고 있는가?</td>
              <td>
                <ul>
                  <li>투여약물의 주요 약물이상반응 증상 확인</li>
                  <li>대표적인 약물이상반응 확인</li>
                  <ul>
                    <li>낮시간 동안의 진정</li>
                    <li>최근 낙상 여부</li>
                    <li>명 등의 출혈 징후</li>
                    <li>저혈당 증상</li>
                    <li>저혈압/어지러움/서맥</li>
                    <li>변비, 설사</li>
                    <li>입마름</li>
                  </ul>
                  <li>
                    약물이상반응을 해결하기 위한 약제는 없는가? (Prescribing cascade - 예,
                    항콜린약제 복용 후 변비약)
                  </li>
                  <li>최근 응급실/입원 방문 여부, 사유 확인</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>현재 약물이상반응의 위험이 높은가?</td>
              <td>
                <ul>
                  <li>임상적으로 유의한 약물-질병 상호작용(질병 금기 확인)</li>
                  <ul>
                    <li>허가사항</li>
                    <li>약물검토 도구(질병 특이적 PIM)</li>
                  </ul>
                  <li>임상적으로 유의한 약물(일반약 포함)-약물 상호작용</li>
                  <ul>
                    <li>약물검토 도구</li>
                    <li>상호작용 데이터베이스</li>
                  </ul>
                  <li>상호작용/신기능에 따른 적절성 평가</li>
                  <ul>
                    <li>허가사항</li>
                    <li>약물검토 도구</li>
                  </ul>
                  <li>제형 선택의 적절성: 분할/분쇄 가능성 확인</li>
                  <ul>
                    <li>장용정/서방정 확인</li>
                  </ul>
                  <li>노인 잠재적 부적절의약품(PIM)</li>
                  <ul>
                    <li>약물검토 도구</li>
                    <li>환자 개별화된 접근</li>
                  </ul>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[5단계] 경제성, 비용</th>
            </tr>
            <tr>
              <td>처방이 경제적인가?</td>
              <td>
                <ul>
                  <li>약물 비용에 대해서 환자가 부담스러워 하는지 확인 후 필요시 대안 고려</li>
                  <li>비급여/급여 가능성 확인</li>
                </ul>
              </td>
            </tr>
            <tr className="green-bg">
              <th colSpan={2}>[6단계] 환자충실성</th>
            </tr>
            <tr>
              <td>환자는 처방의 의도대로 약물을 복용할 수 있는가?</td>
              <td>
                <ul>
                  <li>
                    복약순응도 평가: 필수약제 확인 <br />
                    (필수약제: 전문가의 판단없이 중단하면 안되는 약물 확인)
                  </li>
                  <ul>
                    <li>신체기능을 대체하는 약물: levothyroxine</li>
                    <li>증상 악화를 예방하는 약물: 항파킨슨 약제</li>
                    <li>만성질환으로 복용하는 약: 항고혈압제, 항당뇨병약제</li>
                  </ul>
                  <li>환자가 현재 복용하는 약물치료와 결과에 대해 이해하고 있는지 확인</li>
                  <ul>
                    <li>약을 왜 복용하는지 이해하고 있는가?</li>
                    <li>
                      약 복용/사용법에 대해 teach-back 방법으로 다시 확인하기(예, 인슐린, 흡입기)
                    </li>
                  </ul>
                  <li>환자의 상태에 맞춘 약물 복용법 확인</li>
                  <ul>
                    <li>환자가 복용할 수 있는 제형인가?</li>
                    <li>신체(tube-feeding, 연하곤란, 와상)</li>
                    <li>인지상태 고려</li>
                    <li>약 복용 시간의 편의성을 고려했는가? 식전/식후 투여</li>
                    <li>약물요법 간소화 가능성 확인</li>
                  </ul>
                  <li>약 복용 시 도움이 필요한가?</li>
                  <li>처방 의도대로 약을 복용할 수 있는가?</li>
                </ul>
              </td>
            </tr>
          </table>

          <div className="references">
            <h3>참고문헌</h3>
            <ul>
              <li>
                WHO, Medication safety in polypharmacy, 2019: Step-by-step approach to conducting a
                patient-centered medication review
              </li>
              <li>NHS, Polypharmacy guidance realistic prescribing, 2018</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="section">
          <h2>II. 지역사회 거주 노인을 위한 한국형 약물요법 검토 도구</h2>

          <h3>1. 개발 개요</h3>
          <p>
            이 도구는 지역사회 거주 노인 대상으로 약물사용의 적절성을 점검할 수 있는 21개 도구들에
            대한 체계적 문헌고찰을 토대로 작성되었고, 그 중 가장 많이 활용되고 있는 Beers criteria와
            STOPP/START, 국내 도구로 가장 최근에 개발된 Korea 2018, GheOP3S tool (실제 지역약국
            환경에서의 약물처방검토 도구), Amsterdam tool을 주요하게 고려하였습니다. (하단의 전체
            목록 참조)
          </p>
          <p>
            이후 내과/가정의학과/신경과/정신과 전문의와 노인병 전문약사/임상약물학/임상약학 분야의
            전문가를 대상으로 임상적 적절성에 대한 델파이 설문을 통한 합의 과정을 거쳐 도출된 목록에
            대해, 지역사회 거주 노인의 처방조제 및 약물검토 경험이 있는 약사들을 대상으로 전문가
            타당성 검토를 거쳐서 추려진 최종 목록입니다.
          </p>
          <p>약물검토 도구 개발시 참고했던 국내외 약물검토 도구는 다음과 같습니다.</p>

          <table className="ref-table">
            <tr>
              <th style={{ width: "10%" }}>약자</th>
              <th style={{ width: "90%" }}>원문 서지정보</th>
            </tr>
            <tr>
              <td>Beers</td>
              <td>
                2019 American Geriatrics Society Beers Criteria® Update Expert Panel. American
                Geriatrics Society 2019 updated AGS Beers criteria® for potentially inappropriate
                medication use in older adults. J Am Geriatr Soc. 2019;67(4):674-94.
              </td>
            </tr>
            <tr>
              <td>STOPP/ START version 2</td>
              <td>
                O'mahony D, O'sullivan D, Byrne S, O'Connor MN, Ryan C, Gallagher P. STOPP/START
                criteria for potentially inappropriate prescribing in older people: Version 2. Age
                Ageing. 2015;44(2):213-8.
              </td>
            </tr>
            <tr>
              <td>Korean2018</td>
              <td>
                Kim MY, Etherton-Beer C, Kim CB, et al. Development of a consensus list of
                potentially inappropriate medications for Korean older adults. Ann Geriatr Med Res.
                2018;22(3):121-9.
              </td>
            </tr>
            <tr>
              <td>GheOP3S tool</td>
              <td>
                Tommelein E, Petrovic M, Somers A, et al. Older patients' prescriptions screening in
                the community pharmacy: Development of the Ghent older people's prescriptions
                community pharmacy screening (GheOP3S) tool. J Public Health (Oxf).
                2016;38(2):e158-e70.
              </td>
            </tr>
            <tr>
              <td>Beers Alternatives</td>
              <td>
                Hanlon JT, Semla TP, Schmader KE. Alternative medications for medications in the use
                of high-risk medications in the elderly and potentially harmful drug-disease
                interactions in the elderly quality measures. J Am Geriatr Soc. 2015;63(12):e8-e18.
              </td>
            </tr>
            <tr>
              <td>Amsterdam</td>
              <td>
                Mast R, Ahmad A, Hoogenboom SC, et al. Amsterdam tool for clinical medication
                review: Development and testing of a comprehensive tool for pharmacists and general
                practitioners. BMC Res Notes. 2015;8:642.
              </td>
            </tr>
            <tr>
              <td>EU-(7) PIM</td>
              <td>
                Renom-Guiteras A, Meyer G, Thurmann PA. The EU(7)-PIM list: A list of potentially
                inappropriate medications for older people consented by experts from seven European
                countries. Eur J Clin Pharmacol. 2015;71(7):861-75.
              </td>
            </tr>
            <tr>
              <td>TIME</td>
              <td>
                Bahat G, Ilhan B, Erdogan T, et al. Turkish inappropriate medication use in the
                elderly (TIME) criteria to improve prescribing in older adults:
                TIME-to-STOP/TIME-to-START. Eur Geriatr Med. 2020;11(3):491-8.
              </td>
            </tr>
            <tr>
              <td>ES-PIA</td>
              <td>
                Gonzalez-Colaco Harmand M, Aldea-Perona AM, et al; , Boada-Fernández Del Campo C.
                Spanish list of potentially inappropriate drugs in the elderly (ES-PIA project). Eur
                J Clin Pharmacol. 2019;75(8):1161-76.
              </td>
            </tr>
            <tr>
              <td>HEDIS</td>
              <td>
                NCQA. Proposed Changes to Existing Measures for HEDIS® 2020: Use of High-Risk
                Medications in the Elderly (DAE) and Potentially Harmful Drug-Disease Interactions
                in the Elderly (DDE). HEDIS Public. Published online 2020:1-22. Available from
                https://www.ncqa.org/wp-content/uploads/2019/02/20190208_16_DAE_DDE.pdf. Accessed
                February 1, 2021.
              </td>
            </tr>
            <tr>
              <td>Taiwan list</td>
              <td>
                Chang C-B, Lai H-Y, Hwang S-J, et al. The updated PIM-Taiwan criteria: a list of
                potentially inappropriate medications in older people. Ther Adv Chronic Dis.
                2019;10:2040622319879602.
              </td>
            </tr>
            <tr>
              <td>Chinese criteria</td>
              <td>
                Yuqin W. Criteria of potentially inappropriate medications for older adults in
                China. Adverse Drug Reaction Journal. 2018;20(1):9-14.
              </td>
            </tr>
            <tr>
              <td>GheOP3S-renal</td>
              <td>
                Wazzan AAA, Tommelein E, Foubert K, et al. Development and application of the
                GheOP3S-tool addendum on potentially inappropriate prescribing (PIP) of renally
                excreted active drugs (READs) in older adults with polypharmacy. Drugs Aging.
                2018;35(4):343-54.
              </td>
            </tr>
            <tr>
              <td>STOPP-J</td>
              <td>
                Kojima T, Mizukami K, Tomita N, et al. Screening tool for older persons' appropriate
                prescriptions in Japanese: report of the Japan geriatrics society working group on
                "Guidelines for medical treatment and its safety in the elderly." Geriatr Gerontol
                Int. 2016;16(9):983-1001.
              </td>
            </tr>
            <tr>
              <td>Brazilian criteria</td>
              <td>
                Oliveira MG, Amorim WW, Oliveira CRB, Coqueiro HL, Gusmão LC, Passos LC. Consenso
                brasileiro de medicamentos potencialmente inapropriados para idosos. Geriatrics,
                Gerontology and Aging. 2016;10(4):168-81.
              </td>
            </tr>
            <tr>
              <td>Korean 2015</td>
              <td>
                Kim SO, Jang S, Kim CM, Kim YR, Sohn HS. Consensus validated list of potentially
                inappropriate medication for the elderly and their prevalence in South Korea. Int J
                Gerontol. 2015;9(3):136-41.
              </td>
            </tr>
            <tr>
              <td>PRISCUS</td>
              <td>
                Holt S, Schmiedl S, Thurmann PA. Potentially inappropriate medications in the
                elderly: The PRISCUS List. Dtsch Arztebl Int. 2010;107(31-32):543-51.
              </td>
            </tr>
            <tr>
              <td>RASP list</td>
              <td>
                Van Der Veen L, Decoutere L, Flaming J, et al. Development and validation of the
                RASP list (Rationalization of Home Medication by an Adjusted STOPP list in Older
                Patients): A novel tool in the management of geriatric polypharmacy. Eur Geriatr
                Med. 2014;5(3):175-80.
              </td>
            </tr>
            <tr>
              <td>Clyne</td>
              <td>
                Clyne B, Bradley MC, Hughes CM, et al. Addressing potentially inappropriate
                prescribing in older patients: Development and pilot study of an intervention in
                primary care (the OPTI-SCRIPT study). BMC Health Serv Res. 2013;13:307.
              </td>
            </tr>
            <tr>
              <td>Austrian criteria</td>
              <td>
                Mann E, Bohmdorfer B, Fruhwald T, et al. Potentially inappropriate medication in
                geriatric patients: The Austrian consensus panel list.
              </td>
            </tr>
            <tr>
              <td>Czech criteria</td>
              <td>
                Fialová D, Topinková E, Ballokova A, Matejovska-Kubesova H. Expert consensus of the
                Czech Republic 2012 in the field of pharmaceuticals and drug procedures potentially
                inappropriate in old age. Klinicka Farmakologie a Farmacie. 2013;27(1):18-28.
              </td>
            </tr>
          </table>

          <p>본 도구의 개발 결과는 국제학술지인 Journal of Public Health에 출판될 예정입니다.</p>
          <p>
            이 목록은 요양시설 거주 노인을 위한 한국형 약물검토 도구와 함께 개발되었으며, 요양시설
            거주 노인을 위한 도구도 국제학술지 Therapeutic Advances in Chronic Disease에
            출판되었습니다(Therapeutic Advances in Chronic Disease, 08 Oct 2022,
            13:20406223221128444).
          </p>

          <br />
          <br />
          <h3>2. 도구의 구성</h3>
          <p>
            도출된 도구는 부적절 약물사용 영역 5개, 81개 항목으로 구성되어 있으며, 실제 현장에서의
            적용 효율성을 고려하여 각 항목을 질병상태(23개 분류)로 분류하여 제시하였습니다. 5개
            영역의 구성은 다음과 같습니다.
          </p>

          <ul className="definition">
            <p>
              <strong>PIM: </strong>별도의 조건 없이 잠재적으로 부적절한 의약품
            </p>
            <p>
              <strong>DDI: </strong>약물상호작용으로 인하여 잠재적으로 부적절한 의약품
            </p>
            <p>
              <strong>Ds-PIM: </strong>질병 조건으로 인하여 잠재적으로 부적절한 의약품
            </p>
            <p>
              <strong>Dose: </strong>용량 조건으로 인하여 잠재적으로 부적절한 의약품
            </p>
            <p>
              <strong>Omission: </strong>필요한 처방의 누락 또는 저용량으로 인하여 잠재적으로
              부적절한 의약품
            </p>
          </ul>

          <br />
          <div className="diseases-list">
            <p>
              <strong>23개 기저질환군</strong>
              <br />
              고혈압, 심부전, 심방세동/심부정맥혈전증, 단순 부종, 제2형 당뇨병, 만성신부전,
              폐경기증후군, 근골격계 질환(관절증, 퇴행성/류마티스 관절염), 골다공증, 통증, 낙상
              기왕력, 천식/만성폐쇄성폐질환, 위장관질환, 변비, 비뇨생식기 질환(전립선비대증,
              요실금), 불면증, 인지기능저하/치매/섬망, 기립성 저혈압, 파킨슨병, 신경정신병질환,
              폐쇄우각 녹내장
            </p>
          </div>
          <br />
          <table className="main-table">
            <tr className="blue-header">
              <th style={{ width: "7%" }}>번호</th>
              <th style={{ width: "12%" }}>유형</th>
              <th style={{ width: "62%" }}>항목 및 권고안</th>
              <th style={{ width: "15%" }}>참조</th>
            </tr>
            <tr id="CCMM_ALL_001">
              <td style={{ whiteSpace: "nowrap" }}>1</td>
              <td>[Omission]</td>
              <td>
                계절성 독감 백신, 매년 해당 시기
                <ul>
                  <li>확인 및 권고</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [START]
                <br />
                [TIME] 등
              </td>
            </tr>
            <tr id="CCMM_ALL_002">
              <td style={{ whiteSpace: "nowrap" }}>2</td>
              <td>[Omission]</td>
              <td>
                폐구균 백신, 65 세 이상에서 최소 1 회 접종
                <ul>
                  <li>확인 및 권고</li>
                  <li>
                    현재 국가에서는 65 세 이상 노인에서 23 가 다당백신(PPSV23) 1 회 무료접종을
                    지원함.
                  </li>
                </ul>
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [STOPP-J]
              </td>
            </tr>
            <tr id="CCMM_ALL_003">
              <td style={{ whiteSpace: "nowrap" }}>3</td>
              <td>[Omission]</td>
              <td>
                영양불량인 저체중 환자의 경우 경구영양보충제(예, 엔커버, 뉴케어, 그린비아 등) 추천
                <br />
                <div style={{ backgroundColor: "#f5f5f5", padding: "5px" }}>
                  [참고] 지역사회에서의 영양불량 평가
                  <br />
                  유럽정경영양학회(ESPEN)에서는 지역사회 환경에서 영양불량 증상 선별
                  도구(Malnutrition Universal Screening Tool, MUST)를 이용하도록 권장하였음.
                  <div style={{ margin: "10px 0" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "2px",
                        margin: "10px 0",
                      }}
                    >
                      <table
                        style={{
                          border: "1px solid #000",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                        }}
                      >
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            BMI kg/m²
                          </th>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            Score
                          </th>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            &gt;20
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            0
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            18.5-20
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            1
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            &lt;18.5
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            2
                          </td>
                        </tr>
                      </table>

                      <table
                        style={{
                          border: "1px solid #000",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                          margin: "5px",
                        }}
                      >
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            과거 3-6개월간
                            <br />
                            체중감소 있는 경우(%)
                          </th>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            Score
                          </th>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            &lt;5
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            0
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            5-10
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            1
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            &gt;10
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            2
                          </td>
                        </tr>
                      </table>

                      <table
                        style={{
                          border: "1px solid #000",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                          margin: "5px",
                        }}
                      >
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                              width: "120px",
                            }}
                          >
                            환자치료 혹은 응급으로
                            <br />
                            향후 상당한 5일 이상이
                            <br />
                            경과 또는 기대되지
                            <br />
                            않는 경우
                          </th>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            score 2
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div style={{ textAlign: "center", margin: "10px 0" }}>
                      <span style={{ fontSize: "20px" }}>↓</span>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", margin: "2px 0" }}>
                      <table
                        style={{
                          border: "1px solid #000",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                        }}
                      >
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            Score
                          </th>
                          <th
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            영양불량 위험
                          </th>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            0
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            낮은 영양불량 위험
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            1
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            중등도의 위험
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            2 이상
                          </td>
                          <td
                            style={{
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            높은 위험
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                영양불량 점수와 관계없이, 필요한 경우 식이에 대한 조언을 제공
                <br />
                <table
                  style={{ border: "0", borderCollapse: "collapse", margin: "0", padding: "0" }}
                >
                  <tr>
                    <td style={{ border: "0", padding: "0", whiteSpace: "nowrap" }}>(0 점)</td>
                    <td style={{ border: "0", padding: "0" }}>
                      영양불량위험이 낮은 75 세 이상 노인은 매년 영양평가 권장
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "0", padding: "0", whiteSpace: "nowrap" }}>(1 점)</td>
                    <td style={{ border: "0", padding: "0" }}>
                      중등도의 영양불량위험인 경우 3 일간 식이 기록을 확인하여 적절한 경우 2-3
                      개월마다 영양평가 권장. 부적절한 경우 전반적인 영양 섭취 개선및 정기적
                      모니터링 권장
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "0", padding: "0", whiteSpace: "nowrap" }}>(2 점)</td>
                    <td style={{ border: "0", padding: "0" }}>
                      높은 영양불량 위험 상태인 경우 영양사에게 의뢰하고, 영양 목표를 설정, 전반적인
                      영양 섭취 개선 및 매달 관리 계획 모니터링 및 검토 권장.
                    </td>
                  </tr>
                </table>
              </td>
              <td>[TIME]</td>
            </tr>
            <tr id="CCMM_ALL_004">
              <td style={{ whiteSpace: "nowrap" }}>4</td>
              <td>[PIM]</td>
              <td>
                1 세대 항히스타민제*: 항콜린 특성으로 인해 구갈, 변비, 요저류, 인지기능 저하 등
                부작용 가능
                <ul>
                  <li>
                    알레르기/가려움, 감기 목적으로 사용한 경우 사용 목적이 지속되는지 증상을
                    확인하고, 증상이 없을 경우 중단 권고
                  </li>
                  <li>
                    1주일 이상 사용하여도 증상 조절이 필요한 경우 2 세대 항히스타민제로 변경 권고
                  </li>
                  <li>
                    2세대 항히스타민제를 사용하였으나 증상이 조절되지 않아 사용하고 있는 경우 부작용
                    모니터링
                  </li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  * 1 세대 항히스타민제: 전문∙일반의약품이 모두 포함됨. 종합감기약에도 1 세대
                  항히스타민제 성분이 포함되어있음을 고려해야 함.[예, 하벤큐연질캡슐, 판피린큐액,
                  코대원시럽, 코데날시럽, 코푸시럽 등]
                </span>
              </td>
              <td>
                [GheOP3S]
                <br />
                [Beers]
                <br />
                [STOPP]
                <br />
                [TIME] 등
              </td>
            </tr>
            <tr id="CCMM_ALL_005">
              <td style={{ whiteSpace: "nowrap" }}>5</td>
              <td>[PIM]</td>
              <td>
                구역, 구토, 어지러움 증상 완화 목적의 1 세대 항히스타민제*: 항콜린 특성으로 인해
                구갈, 변비, 요저류, 인지기능 저하 등 부작용 가능
                <ul>
                  <li>어지러움 치료 목적으로 사용된 경우 원인사 느끼는 치료 효과 평가</li>
                  <li>효과가 없는 경우 중단 권고</li>
                  <li>
                    항콜린성 약제로 인한 부작용이 우려상을 초래하는 경우 다른 약으로 전환 권고
                    <sup>#</sup>
                  </li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  * 구역, 구토, 어지러움 증상 완화 목적의 1 세대 항히스타민제 : 예,dimenhydrinate
                  (제품명: 보나링에이정, 에르버트정 등), meclizine (제품명: 엠클리진정) 등
                </span>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  <sup>#</sup> 메니에르병에 의한 어지러움, 이명, 청력 소실 적응증이 있는 다른 약은
                  국내 betahistine 이 있으며(임상 효과의 동등성은 입증되지 않음), 이 약은 항콜린성
                  특성이 강하다고 분류되는 약은 아님.
                </span>
              </td>
              <td>
                [GheOP3S]
                <br />
                [Beers]
                <br />
                [STOPP]
                <br />
                [TIME] 등
              </td>
            </tr>
            <tr id="CCMM_ALL_006">
              <td style={{ whiteSpace: "nowrap" }}>6</td>
              <td>[DDI]</td>
              <td>
                강한 항콜린성 약제(일반약 포함) 2 종 이상 사용: 항콜린 특성으로 인해 구갈, 변비,
                요저류, 인지기능 저하 등 부작용 가능
                <ul>
                  <li>항콜린성 약제 중 중단이나 변경이 가능한 약이 있는지 확인 필요</li>
                  <li>특히, 항콜린성 부작용이 있는 경우, 대체 가능한 약이 있다면 변경 제안</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [TIME]
                <br />
                [Beers] 등
              </td>
            </tr>
            <tr id="CCMM_ALL_007">
              <td style={{ whiteSpace: "nowrap" }}>7</td>
              <td>[Dose]</td>
              <td>
                철분제, 원소 철로 200 mg/day 초과(ferrous sulfate 로 600mg 초과) 용량의 경구 철분제:
                초과 용량에서 철분 흡수가 증가한다는 증거 없으며, 변비 위험
                <ul>
                  <li>명확한 적응증이 없는 경우 중단</li>
                  <li>
                    심한 변비를 호소하거나 빈혈이 지속되고 철결핍성 빈혈이 교정되지 않는 경우
                    투여경로 변경 고려
                  </li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  [참고] 훼로바유서방정
                  <br />
                  - 남성: ferrous sulfate 256mg(원소철로서 80mg)/1 정
                  <br />- 허가사항 기준 1 일 2 회까지 가능
                </span>
              </td>
              <td>
                [STOPP]
                <br />
                [Czech]
                <br />
                [EU-PIM]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>고혈압</td>
            </tr>
            <tr id="CCMM_Hypertension_008">
              <td style={{ whiteSpace: "nowrap" }}>8</td>
              <td>[Ds-PIM]</td>
              <td>
                3 종 이상의 고혈압 약제를 사용하는 환자에서 NSAID (일반약 포함) 지속적 사용: 고혈압
                악화 위험
                <ul>
                  <li>
                    적응증, 통증 조절 여부, 이전 진통제 사용력 평가 후 NSAID 의 중단 및 변경 가능성
                    확인 및 적절한 진통제 추천
                  </li>
                  <li>혈압조절 정도, 고혈압 약제 복약순응도 확인 및 교육</li>
                </ul>
              </td>
              <td>
                [Korea2018]
                <br />
                [STOPP]
                <br />
                [Amsterdam]
                <br />
                [TIME] 등
              </td>
            </tr>
            <tr id="CCMM_Hypertension_009">
              <td style={{ whiteSpace: "nowrap" }}>9</td>
              <td>[Ds-PIM]</td>
              <td>
                통풍을 진단받은 환자에서 hydrochlorothiazide 계 이뇨제 사용: 통풍 악화 가능
                <ul>
                  <li>
                    재발성 통풍 또는 요산 수치가 지절되지 않는 경우 다른 계열의 항고혈압 약제로
                    변경이 가능한지 확인 및 변경 추천
                  </li>
                  <li>
                    이뇨제 필요 시 칼륨보존이뇨제 이용: 신부전 환자나 RAS 억제제 사용 중인 환자의
                    경우 고칼륨혈증 유발 상호작용 주의
                  </li>
                  <li>
                    Hydrochlorothiazide 이뇨제를 12.5 mg 이하의 저용량으로 사용하고 있으면서
                    통풍/요산 조절이 잘되는 경우 약제 변경 없이 모니터링
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [STOPP]
                <br />
                [TIME]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Hypertension_010">
              <td style={{ whiteSpace: "nowrap" }}>10</td>
              <td>[Ds-PIM]</td>
              <td>
                전립선비대증이 있는 환자에서 고혈압 1 차 치료제로 알파차단제 사용: 기립성 저혈압,
                낙상 위험
                <ul>
                  <li>다른 대체약 있는 경우 변경 권고</li>
                  <li>저혈압, 기립성 저혈압 확인</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Korea2018]
                <br />
                [PRISCUS]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_Hypertension_011">
              <td style={{ whiteSpace: "nowrap" }}>11</td>
              <td>[DDI]</td>
              <td>
                RAS 억제제와 칼륨보충제 또는 칼륨보존이뇨제를 지속적으로 병용: 고칼륨혈증 위험
                <ul>
                  <li>
                    특히 신부전 환자에서 주의가 필요하며, 정기적으로 혈중 전해질(칼륨 포함)을
                    모니터링 하며 병용 중인지 평가
                  </li>
                  <li>
                    신부전 환자의 경우 병용이 필요한 경우가 있으므로 이 경우 정기적인 진료와
                    모니터링이 이루어지는지 확인
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [OPTI-SCRIPT criteria]
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_012">
              <td style={{ whiteSpace: "nowrap" }}>12</td>
              <td>[Omission]</td>
              <td>
                80 세 미만의 스스로 거동이 가능한 노인에서 2 회 이상의 서로 다른 날 확인한 수축기
                혈압이 160 mmHg 초과/이완기 혈압이 90 mmHg 초과인 경우 고혈압치료제 처방 여부 확인
                <br />
                <br />
                [참고] 대한고혈압학회 지침에서는 80 세 이상의 쇠약한 노인의 경우 수축기 혈압이 160
                mmHg 이상이면 치료 시작 권장
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>허혈성 심장질환(협심증, 급성관동맥후군, 심근경색), 뇌졸중, TIA</td>
            </tr>
            <tr id="CCMM_Cardiovascular_013">
              <td style={{ whiteSpace: "nowrap" }}>13</td>
              <td>[Omission]</td>
              <td>
                항혈소판제 사용 환자(특히 이중항혈소판제 사용 환자가 NSAID (일반약 포함)을 1 주일
                이상 지속적으로 사용 중인 경우, 적절한 소화성궤양방지제(PPI 우선 추천, H2RA 근거
                약함) 처방되지 않은 경우: 위장관 출혈 위험
                <ul>
                  <li>NSAID 의 중단 및 변경 가능성 확인</li>
                  <li>
                    NSAID 지속 필요시 소화성궤양용제(PPI 안전, H2RA 근거 약함) 추천
                    <br /> 단, clopidogrel 을 사용 중에 있을 때에는 omeprazole 또는 esomeprazole 을
                    추천하지 않음
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [TIME] 등
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_014">
              <td style={{ whiteSpace: "nowrap" }}>14</td>
              <td>[DDI]</td>
              <td>
                Nitrate 제제* 사용 환자에서 PDE5 억제제(예, sildenafil, vardenafil) 사용: 중증
                저혈압, 심근허혈 촉진 위험
                <ul>
                  <li>심혈관계 질환 담당 의사로부터 PDE5 억제제 사용 가능성 문의</li>
                  <li>
                    PDE5 억제제 병용 중단 권고, 단, 필요시 사용이 필요하고 의사로부터 사용이
                    가능하다고 확인받은 경우 병용금기 시간 확인
                  </li>
                </ul>
                *Nitrate 제제: isosorbide, nicorandil 포함
                <br />
                <br />
                [참고] 병용금기 시간
                <br />
                • sildenafil, vardenafil: 최소 24 시간
                <br />
                • tadalafil: 최소 48 시간
                <br />• mirodenafil, udenafil: 자료부족
              </td>
              <td>
                [Amsterdam]
                <br />
                [TIME]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_015">
              <td style={{ whiteSpace: "nowrap" }}>15</td>
              <td>[PIM]</td>
              <td>
                속효성 nifedipine 처방: 저혈압, 급몰허혈 촉진 위험 증가
                <ul>
                  <li>지속형 제형 또는 같은 계열의 다른 항고혈압제로의 전환 추천</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Amsterdam]
                <br />
                [PRISCUS] 등
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_016">
              <td style={{ whiteSpace: "nowrap" }}>16</td>
              <td>[Omission]</td>
              <td>
                심부전 그리고/또는 심근경색 환자에서 ACEI 또는 ARB 사용 여부 확인
                <ul>
                  <li>금기/주의점한 여부 확인</li>
                  <li>환자 의무증단 여부 확인</li>
                  <li>미사용 이유 확인 및 사용 권고</li>
                </ul>
                [참고] ACC/AHA 가이드라인에 심근경색, 심부전 환자에서 RAS 억제제가 생존율 증가에
                중요한 역할을 하고 있음이 제시됨
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_017">
              <td style={{ whiteSpace: "nowrap" }}>17</td>
              <td>[Omission]</td>
              <td>
                과거 심근경색, 관상동맥 스텐트 시술, 관상동맥우회술, 뇌혈관 스텐트, 과거 뇌졸중,
                일과성뇌허혈성발작, 말초동맥혈관질환 환자에서 심혈관계질환 이차 예방 목적의 스타틴
                치료 확인
                <ul>
                  <li>금기/주의질환 여부 확인</li>
                  <li>환자 임의증단 여부 확인</li>
                  <li>미사용 이유 확인 및 권고</li>
                </ul>
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [Amsterdam]
                <br />
                [Korea2018]
              </td>
            </tr>
            <tr id="CCMM_Cardiovascular_018">
              <td style={{ whiteSpace: "nowrap" }}>18</td>
              <td>[Omission]</td>
              <td>
                과거 심근경색, 관상동맥 스텐트 시술, 관상동맥우회술, 뇌혈관 스텐트, 과거 뇌졸중,
                일과성뇌허혈성발작, 말초동맥혈관질환 환자에서 심혈관계질환 이차 예방 목적의 스타틴
                치료 확인
                <ul>
                  <li>예외: 말기 노쇠 환자, 85 세 초과 환자</li>
                  <li>금기/주의질환 여부 확인</li>
                  <li>환자 임의증단 여부 확인</li>
                  <li>미사용 이유 확인 및 사용 권고</li>
                </ul>
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [Amsterdam]
                <br />
                [STOPP-J]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>심부전</td>
            </tr>
            <tr id="CCMM_HeartFailure_019">
              <td style={{ whiteSpace: "nowrap" }}>19</td>
              <td>[Ds-PIM]</td>
              <td>
                심부전 환자에서 NSAID (일반약 포함) 지속적 사용: 심부전 악화 위험 증가
                <ul>
                  <li>NSAID 중단 및 변경 추천</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Korea2018]
                <br />
                [STOPP]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_HeartFailure_020">
              <td style={{ whiteSpace: "nowrap" }}>20</td>
              <td>[DDI]</td>
              <td>
                이뇨제, 특히 loop 계 이뇨제[예, furosemide, torsemide 등]와 NSAIDs (일반약 포함)의
                병용: 이뇨제에 대한 반응 감소 및 급성 신손상 위험 증가
                <ul>
                  <li>NSAID 의 중단 및 변경 추천</li>
                  <li>NSAID 사용 필요시 신기능, 혈압, 전해질 모니터링, 탈수 여부 확인 필요</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [OPTI-SCRIPT criteria]
              </td>
            </tr>
            <tr id="CCMM_HeartFailure_021">
              <td style={{ whiteSpace: "nowrap" }}>21</td>
              <td>[DDI]</td>
              <td>
                ACEI 와 ARB 병용
                <ul>
                  <li>의도적 병용 여부 확인 후 의도적 병용이 아닌 경우 병용 중단 및 변경 추천</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [ES-PIA]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_HeartFailure_022">
              <td style={{ whiteSpace: "nowrap" }}>22</td>
              <td>[Omission]</td>
              <td>
                체액과잉 상태로 인한 증상[예, 체중증가, 부종, 호흡곤란 등]이 있는 심부전 환자에서
                이뇨제 처방 여부
                <ul>
                  <li>금기/주의질환 여부 확인</li>
                  <li>환자 임의중단 여부 확인</li>
                  <li>미사용 이유 확인 및 권고</li>
                </ul>
              </td>
              <td>[Amsterdam]</td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>심방세동, 심부정맥혈전증</td>
            </tr>
            <tr id="CCMM_Thrombosis_023">
              <td style={{ whiteSpace: "nowrap" }}>23</td>
              <td>[DDI]</td>
              <td>
                경구용 항응고제와 항혈소판제 병용: 출혈 위험 증가
                <ul>
                  <li>제외: 동일한 처방 의사가 동시 처방하고, 환자가 이를 인지한 경우</li>
                  <li>병용의 명확한 적응증, 의도적 병용 확인</li>
                  <li>항응고제와 Aspirin 병용 시 적절한 소화성궤양용제 사용 여부 확인</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [STOPP-J]
              </td>
            </tr>
            <tr id="CCMM_Thrombosis_024">
              <td style={{ whiteSpace: "nowrap" }}>24</td>
              <td>[DDI]</td>
              <td>
                Warfarin 과 sulfamethoxazole/trimethoprim 병용: 출혈 위험 증가
                <ul>
                  <li>INR 모니터링, 용량조절 후 사용 여부</li>
                  <li>
                    다른 항생제로 변경 가능성 확인(참고, 예방목적의 저용량 사용 시에는 상호작용이
                    흔하게 나타나지는 않음)
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr id="CCMM_Thrombosis_025">
              <td style={{ whiteSpace: "nowrap" }}>25</td>
              <td>[DDI]</td>
              <td>
                Warfarin 과 마크로라이드계 항균제(clarithromycin 등 포함, 제외: azithromycin),
                퀴놀론계 항균제(ciprofloxacin/ofloxacin 등) 병용: 출혈 위험 증가
                <ul>
                  <li>INR 모니터링, 용량조절 후 사용 여부</li>
                  <li>다른 항생제로 변경 가능성 확인</li>
                  <li>
                    사용 가능한 항생제가 제한되어 있고, 단기간 사용하면서 모니터링이 가능한 경우에는
                    상호작용 관련 정보를 제공함
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>단순 부종</td>
            </tr>
            <tr id="CCMM_Edema_026">
              <td style={{ whiteSpace: "nowrap" }}>26</td>
              <td>[Ds-PIM]</td>
              <td>
                심부전, 간경변, 만성신부전, 신증후군 등이 없는 환자에서 단순 부종에 루프계
                이뇨제(furosemide)의 지속적 사용
                <ul>
                  <li>비약물요법 추천</li>
                  <li>탈수 및 전해질 장애 여부의 중간 점검 필요</li>
                  <li>칼슘채널차단제에 의한 발목 부종 확인</li>
                </ul>
              </td>
              <td>
                [STOPP]
                <br />
                [TIME]
                <br />
                [Amsterdam] 등
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>제2형 당뇨병</td>
            </tr>
            <tr id="CCMM_Diabetes_027">
              <td style={{ whiteSpace: "nowrap" }}>27</td>
              <td>[PIM]</td>
              <td>
                장시간 지속형 sulfonylurea (glimepiride, glibenclamide) 사용: 저혈당 위험 증가
                <ul>
                  <li>일차치료제인 metformin 사용 여부 및 사용 기왕력 확인</li>
                  <li>저혈당 발생 여부, 혈당조절 여부 확인</li>
                  <li>
                    단시간 지속형 sulfonylurea [예, Gliclazide IR] 또는 다른 계열의 경구용
                    혈당강하제 추천
                  </li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Amsterdam]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Diabetes_028">
              <td style={{ whiteSpace: "nowrap" }}>28</td>
              <td>[Ds-PIM]</td>
              <td>
                당뇨병 환자에서 1 주 이상 경구 스테로이드 사용 중 혈당 모니터링을 하지 않고 있는
                경우
                <ul>
                  <li>혈당 모니터링 권고</li>
                  <li>가능한 치료 기간 단축, 혈당조절 안될 가능성에 대해서 환자 교육</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Diabetes_029">
              <td style={{ whiteSpace: "nowrap" }}>29</td>
              <td>[Ds-PIM]</td>
              <td>
                당뇨병 환자에서 비선택적 베타차단제[예외, sotalol] 사용: 저혈당 증상 은폐 가능
                <ul>
                  <li>
                    적응증 확인 후, 선택적 베타차단제 또는 대체가능한 다른 치료제로 변경 추천(특히,
                    저혈당 과거력 환자의 경우 변경 검토 필수)
                  </li>
                  <li>
                    정기적인 혈당 검사 추천, 저혈당 증상 및 모니터링에 대한 환자 교육 특히 중요
                  </li>
                </ul>
              </td>
              <td>
                [Amsterdam]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Diabetes_030">
              <td style={{ whiteSpace: "nowrap" }}>30</td>
              <td>[Omission]</td>
              <td>
                80 세 미만의 스스로 거동이 가능한 노인이며, 2 회 이상의 서로 다른 날 확인된 수축기
                혈압이 140 mmHg 을 초과하는 당뇨병 환자이나 항고혈압제 사용하고 있지 않은 경우
                <ul>
                  <li>고혈압 조절 필요성 교육 및 진료 권고</li>
                  <li>환자 임의 중단 여부 확인 및 미사용 여부 확인 및 권고 추가</li>
                </ul>
              </td>
              <td>
                [TIME]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Diabetes_031">
              <td style={{ whiteSpace: "nowrap" }}>31</td>
              <td>[Ds-PIM]</td>
              <td>
                말기신부전 또는 투석 환자에서 metformin 사용: 젖산산증의 위험 증가
                <ul>
                  <li>다른 혈당강하제로의 전환 추천</li>
                </ul>
              </td>
              <td>
                [RASP]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>만성신부전, 투석, 말기신부전</td>
            </tr>
            <tr id="CCMM_KidneyDisease_032">
              <td style={{ whiteSpace: "nowrap" }}>32</td>
              <td>[Ds-PIM]</td>
              <td>
                신부전 환자에서 NSAIDs 의 지속적 사용: 신기능 악화 위험
                <ul>
                  <li>
                    다른 대체 약물 확인: Topical NSAIDs, acetaminophen 서방형 등으로의 변경 가능성
                    확인
                  </li>
                  <li>부작용 모니터링</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr id="CCMM_KidneyDisease_033">
              <td style={{ whiteSpace: "nowrap" }}>33</td>
              <td>[Omission]</td>
              <td>
                중증의 신기능 저하 환자(CrCl &lt; 30 mL/min)에서 비타민 D (Vit D) 치료
                <ul>
                  <li>사용력 확인</li>
                  <li>칼슘/인 농도를 고려한 의도적인 미사용 여부 확인</li>
                </ul>
              </td>
              <td>
                [Amsterdam]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>폐경기증후군</td>
            </tr>
            <tr id="CCMM_Menopause_034">
              <td style={{ whiteSpace: "nowrap" }}>34</td>
              <td>[PIM]</td>
              <td>
                Estrogen 포함 호르몬 대체요법: 관상동맥질환, 뇌졸중, 혈전증, 유방암 발생 위험 증가
                <ul>
                  <li>이용 사유 및 기간 확인</li>
                  <li>비뇨생식계 문제로 사용 중인 경우 국소 제제 사용</li>
                  <li>
                    중단 권고, 특히 유방암, 정맥혈전 등 병력 있고 정기적으로 임상적 추적관찰이
                    이루어지지 않는 경우
                  </li>
                  <li>
                    혈관운동증상(안면홍조 등)에서는 SSRI, SNRI, gabapentin 등 사용 고려(단, 오프라벨
                    사용임)
                  </li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Korean2018]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>근골격계: 관절증, 퇴행성 관절염, 류마티스 관절염</td>
            </tr>
            <tr id="CCMM_JointDisorders_035">
              <td style={{ whiteSpace: "nowrap" }}>35</td>
              <td>[PIM]</td>
              <td>
                경구 NSAIDs (일반약 포함) 사용: 고위험 환자군에서 출혈 위험 증가 및 혈압 상승,
                신손상 위험 증가
                <br />
                [고위험 환자군: 75 세 초과 환자, 경구 스테로이드제, 항응고제, 항혈전제 복용 환자]
                <ul>
                  <li>
                    다른 대체 약물 확인: 국소 NSAIDs, acetaminophen 서방형 등으로의 조절 가능성 확인
                  </li>
                  <li>NSAID 지속 필요시 소화성궤양용제[예, PPI] 병용 확인 및 추천</li>
                  <li>신기능 및 혈압 모니터링 필요</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_036">
              <td style={{ whiteSpace: "nowrap" }}>36</td>
              <td>[DDI]</td>
              <td>
                항혈전제(항응고제)와 NSAIDs (일반약 포함) 병용: 출혈 위험 증가
                <ul>
                  <li>
                    NSAID 의 중단 및 변경[예, acetaminophen 또는 tramadol, 마약성 진통제] 가능성
                    확인: 출혈 위험 증가
                  </li>
                  <li>반드시 소화성궤양용제[예, PPI] 병용</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_037">
              <td style={{ whiteSpace: "nowrap" }}>37</td>
              <td>[DDI]</td>
              <td>
                NSAIDs/Coxib 와 ACE 억제제/ARB 병용: 신손상 위험 증가
                <ul>
                  <li>다른 진통제로 변경 고려</li>
                  <li>탈수 상황에서 NSAID 일시중단 권고</li>
                </ul>
              </td>
              <td>
                [ES-PIA]
                <br />
                [OPTI-SCRIPT criteria]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_038">
              <td style={{ whiteSpace: "nowrap" }}>38</td>
              <td>[DDI]</td>
              <td>
                NSAIDs (일반약 포함)와 경구 스테로이드 병용: 출혈 위험 증가
                <ul>
                  <li>
                    NSAID 의 중단 및 변경[예, acetaminophen 또는 tramadol, 마약성 진통제] 가능성
                    확인
                  </li>
                  <li>반드시 소화성궤양용제 병용</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_039">
              <td style={{ whiteSpace: "nowrap" }}>39</td>
              <td>[Ds-PIM]</td>
              <td>
                심혈관질환 환자에서 COX2 선택적 억제제 사용: 심혈관 사건 발생 위험 증가
                <ul>
                  <li>다른 계열의 진통제로 변경 고려</li>
                  <li>부종 등 부작용 확인</li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  [참고]
                  <br /> 국내 허가사항에서는 울혈성 심부전 환자(NYHA II - IV), 확립된 허혈성
                  심장질환자, 말초성 동맥질환 환자 및/또는 뇌혈관 질환자, 관상동맥 우회로술(CABG)
                  전후에 발생하는 통증 치료에서 COX2 선택적 억제제[예, celecoxib, etoricoxib,
                  polmacoxib] 를 사용 금기로 명시하였고, 심혈관계 이상반응(심장발작, 뇌졸중 등)에
                  대한 고도의 위험인자를 가진 환자 [예, 고혈압, 고지혈증, 당뇨, 흡연 등],
                  심혈관계질환 또는 그 병력이 있는 환자에서는 신중 사용할 것을 권고함.
                </span>
              </td>
              <td>
                [Beers]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_040">
              <td style={{ whiteSpace: "nowrap" }}>40</td>
              <td>[Omission]</td>
              <td>
                류마티스관절염으로 methotrexate 처방 환자에서 엽산(folic acid) 처방 여부
                <ul>
                  <li>Methotrexate 1 주 1-2 회 투여 요법 중인지 확인</li>
                  <li>
                    엽산 보충제 필요 여부 확인(저용량 MTX 이용 중인 경우 엽산 미처방 가능한 경우
                    있음)
                  </li>
                  <li>환자 임의 중단 여부 확인 및 미사용 여부 확인 및 권고</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [START]
                <br />
                [TIME]
                <br />
                [RASP]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_041">
              <td style={{ whiteSpace: "nowrap" }}>41</td>
              <td>[DDI]</td>
              <td>
                벤조디아제핀계 약물과 마약성 진통제 병용: 진정, 호흡억제, 혼수 및 사망 위험 증가
                <ul>
                  <li>진정 효과, 호흡억제 등의 모니터링</li>
                  <li>중단 가능성 확인(점차적 감량 필요)</li>
                </ul>
              </td>
              <td>
                [ES-PIA]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_JointDisorders_042">
              <td style={{ whiteSpace: "nowrap" }}>42</td>
              <td>[PIM]</td>
              <td>
                항콜린성 근이완제: 항콜린 특성으로 인해 구갈, 변비, 요저류, 인지기능 저하 등 부작용
                가능
                <ul>
                  <li>
                    급성 경, 중등도 통증: Acetaminophen 또는 환자의 위장관출혈, 심혈관계질환,
                    신장질환 위험 요인을 고려하여 NSAIDs 추천(심부전, 신기능저하 없는 경우. 7 일
                    초과 사용시 소화성궤양용제와 함께 추천)
                  </li>
                  <li>반드시 사용해야 할 때 비항콜린성 근이완제 추천[예, eperisone 등]</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Korean2018]
                <br />
                [TIME]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>골다공증</td>
            </tr>
            <tr id="CCMM_Osteoporosis_043">
              <td style={{ whiteSpace: "nowrap" }}>43</td>
              <td>[Omission]</td>
              <td>
                비타민 D 와 칼슘제제 복용 여부 확인 및 추천
                <ul>
                  <li>
                    비타민 D 섭취량과 칼슘섭취량이 부족할 경우(권장 섭취량 칼슘 800-1000 mg, Vit D
                    800IU/day)
                  </li>
                  <li>심내막에만 지나거나 낙상 경험이 있는 환자</li>
                  <li>골다공증 위험이 높은 환자</li>
                  <li>경구 스테로이드 1 개월 초과 복용 환자</li>
                  <li>환자가 처방 이외로 비타민제를 복용하고 있는지 확인</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr id="CCMM_Osteoporosis_044">
              <td style={{ whiteSpace: "nowrap" }}>44</td>
              <td>[Omission]</td>
              <td>
                경구 스테로이드제(prednisolone 7.5mg/일 이상)를 3 개월 이상 사용 환자에서
                칼슘/비타민 D 보충제 처방 확인, 필요한 경우 bisphosphonate 처방 권유
                <ul>
                  <li>
                    Bisphosphonate 의 경우 glucocorticoid 사용 환자에서 국내 급여기준 고려
                    <br />
                    1) 폐경 후 여성 및 만 50 세 이상 남성: T-score &lt; -1.5,
                    <br />
                    2) 폐경 전 여성 및 만 50 세 미만 남성: Z-score &lt; -3.0 /고시 제 2018-253
                    호(2018.12.1.))
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [START]
                <br />
                [Amsterdam] 등
              </td>
            </tr>
            <tr id="CCMM_Osteoporosis_045">
              <td style={{ whiteSpace: "nowrap" }}>45</td>
              <td>[Omission]</td>
              <td>
                골다공증 진단받은 환자(골밀도 T-점수&lt; 2.5)나 과거 취약 골절(골다공증골절)이 있는
                환자에서는 골다공증 치료제 사용 여부 확인
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Osteoporosis_046">
              <td style={{ whiteSpace: "nowrap" }}>46</td>
              <td>[Omission]</td>
              <td>
                Bisphosphonate, Denosumab 치료 환자에서 칼슘/비타민 D 보충제 복용 여부 확인
                <ul>
                  <li>식사로 섭취하는 칼슘 및 비타민 D 섭취량이 충분한지 확인</li>
                </ul>
              </td>
              <td>
                [Amsterdam]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_Osteoporosis_047">
              <td style={{ whiteSpace: "nowrap" }}>47</td>
              <td>[Ds-PIM]</td>
              <td>
                활동성 식도질환 환자, 연하곤란 환자, 와상 상태 환자에서 경구 Bisphosphonate 처방:
                식도 궤양 위험 증가
              </td>
              <td>
                [STOPP]
                <br />
                [TIME]
                <br />
                [RASP]
              </td>
            </tr>
            <tr id="CCMM_Osteoporosis_048">
              <td style={{ whiteSpace: "nowrap" }}>48</td>
              <td>[DDI]</td>
              <td>
                Bisphosphonate 복용법 및 복용 시간 확인: 흡수 저해 및 식도궤양 예방
                <ul>
                  <li>
                    공복 복용 여부(식전 30 분 추천, ibandronate 및 pamidronate 는 식전 1 시간 추천)
                    확인- 공복 복용 여부 교육
                  </li>
                  <li>
                    Bisphosphonate 복용 환자가 칼슘, 아연, 철분이 들어간 비타민, 종합비타민이나
                    제산제를 동시에 복용하는지 확인 - 2 시간 이상 간격을 띄우도록 교육
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>통증</td>
            </tr>
            <tr id="CCMM_Pain_049">
              <td style={{ whiteSpace: "nowrap" }}>49</td>
              <td>[Omission]</td>
              <td>
                암성 통증 등 완화 목적으로 장시간 지속형 마약성 진통제 복용 환자에서 돌발성 통증
                조절을 위한 속효성 마약 처방 여부 확인
                <ul>
                  <li>돌발 통증에 대한 대처법을 알고 있는지 확인</li>
                </ul>
              </td>
              <td>
                [START]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_Pain_050">
              <td style={{ whiteSpace: "nowrap" }}>50</td>
              <td>[Omission]</td>
              <td>
                규칙적인 마약성 진통제(naloxone 복합제 예외) 복용 환자에서 예방적 완하제 처방 여부
                확인
                <ul>
                  <li>팽창성 완하제 이외의 완하제 추천[예, lactulose]]</li>
                  <li>자극성 하제 사용 가능[예, bisacodyl]</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [START]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Pain_051">
              <td style={{ whiteSpace: "nowrap" }}>51</td>
              <td>[Dose]</td>
              <td>
                Tramadol 처음 시작 시 저용량(18.75 mg, 소위'세미' 정)으로 시작, 점차 증량 여부 확인:
                어지러움, 오심, 구토 등 부작용 위험
              </td>
              <td>
                [GheOP'S]
                <br />
                [EU-PIM]
                <br />
                [Chinese]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>낙상 기왕력</td>
            </tr>
            <tr id="CCMM_FallHistory_052">
              <td style={{ whiteSpace: "nowrap" }}>52</td>
              <td>[Ds-PIM]</td>
              <td>
                마약성 진통제, 벤조디아제핀, 항우울제, 항정신병약, 수면진정제, 항전간제 처방: 낙상
                위험 증가
                <ul>
                  <li>
                    중추신경계 억제 약물 사용 약물 개수 및 용량 확인(3 종 미만 이용 및 저용량 사용
                    권고)
                  </li>
                  <li>
                    중추신경계 억제 약물의 적응증, 효과 확인 후 낙상 위험 증가 부작용 알림, 가능한
                    경우 중단 또는 감량
                  </li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [Korea2018]
                <br />
                [HEDIS]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>천식, 만성폐쇄성폐질환</td>
            </tr>
            <tr id="CCMM_RespiratoryConditions_053">
              <td style={{ whiteSpace: "nowrap" }}>53</td>
              <td>[Ds-PIM]</td>
              <td>
                조절되지 않는 천식, 만성폐쇄성폐질환 상태에서 비선택성 베타차단제 사용: 호흡기 증상
                악화 가능
                <ul>
                  <li>적응증에 따라 선택적 베타차단제 또는 다른 계열약제로의 전환 가능성 확인</li>
                </ul>
                [참고] 비선택적 베타차단제: propranolol, carvedilol 등
                <br />
                선택적 베타차단제: atenolol, metoprolol, bisoprolol, nebivolol 등
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [Taiwan]
              </td>
            </tr>
            <tr id="CCMM_RespiratoryConditions_054">
              <td style={{ whiteSpace: "nowrap" }}>54</td>
              <td>[Ds-PIM]</td>
              <td>
                흡입용 스테로이드 사용 대신 경구 스테로이드 사용: 전신 스테로이드 부작용 증가,
                스테로이드 의존성 증가 위험 등
                <ul>
                  <li>스테로이드 치료가 필요한 경우 흡입 스테로이드 이용 권고</li>
                  <li>
                    흡입용 스테로이드 복약순응도 및 사용법 숙지 여부 확인, 순응도 문제로 경구
                    스테로이드가 필요한 것인지 확인
                  </li>
                </ul>
              </td>
              <td>
                [Amsterdam]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_RespiratoryConditions_055">
              <td style={{ whiteSpace: "nowrap" }}>55</td>
              <td>[Omission]</td>
              <td>
                만성폐쇄성폐질환 환자에서 규칙적인 지속성 기관지 확장 흡입제 사용 [예, tiotropium,
                indacaterol, salmeterol, aclidinium, umeclidinium, glycopyrronium 등]
                <ul>
                  <li>
                    금기/주의질환 여부 확인 후 환자 임의 중단 여부 및 미사용 여부 확인하여 사용 권고
                  </li>
                  <li>흡입제 치료의 중요성 설명</li>
                </ul>
              </td>
              <td>
                [START]
                <br />
                [TIME]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>위장관질환</td>
            </tr>
            <tr id="CCMM_Gastrointestinal_056">
              <td style={{ whiteSpace: "nowrap" }}>56</td>
              <td>[PIM]</td>
              <td>
                치료용량의 PPI 8 주 초과 사용: C.difficile 감염 위험 증가 및 골손실, 골절 위험
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  *치료용량의 PPI: esomeprazole 20-40 mg, omeprazole 10-40 mg, pantoprazole 40mg,
                  lansoprazole 30mg, rabeprazole 20mg
                </span>
                <ul>
                  <li>적응증 지속 확인:</li>
                  <li>
                    [예, GERD 증상 지속, 소화성 궤양 증상 지속, NSAID 또는 이중 항혈소판제 이용,
                    경구 스테로이드 지속 복용 상황 등의 경우]
                  </li>
                  <li>지속 필요시 감량 추천</li>
                  <li>적응증 없는 경우 중단 추천</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Gastrointestinal_057">
              <td style={{ whiteSpace: "nowrap" }}>57</td>
              <td>[PIM]</td>
              <td>
                항콜린성 진경제[예, butylscopolamine, dicyclomine (dicycloverine), cimetropium,
                difemerin, oxapium, belladonna alkaloid 등]: 항콜린 특성으로 인해 구갈, 변비,
                요저류, 인지기능 저하 등 부작용 가능
                <ul>
                  <li>적응증 지속 여부 확인, 가능한 한 단기간 사용 추천</li>
                  <li>다른 항콜린성 약제 병용 여부와 부작용 확인</li>
                  <li>항콜린성 효과가 없는 진경제[예, trimebutine]로의 대체 추천</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [STOPP]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_Gastrointestinal_058">
              <td style={{ whiteSpace: "nowrap" }}>58</td>
              <td>[PIM]</td>
              <td>
                Metoclopramide 사용: 추체외로 부작용 위험
                <ul>
                  <li>적응증 확인 및 반드시 필요한 경우 7 일 이내 사용, 비약물요법 권장</li>
                  <li>다른 위장관운동촉진제 추천[예, itopride]</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr id="CCMM_Gastrointestinal_059">
              <td style={{ whiteSpace: "nowrap" }}>59</td>
              <td>[Ds-PIM]</td>
              <td>
                소화성궤양 환자에서 비선택적 NSAIDs 사용: 위장관 출혈위험 증가
                <ul>
                  <li>
                    다른 진통제 또는 심혈관계 질환이 없는 경우 COX 선택적 억제제로의 전환 권고
                  </li>
                  <li>NSAID 지속 필요시 소화성궤양용제[예, PPI] 추천</li>
                  <li>Ketorolac, piroxicam, indomethacin 은 삼갈 것</li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [STOPP]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>변비</td>
            </tr>
            <tr id="CCMM_Constipation_060">
              <td style={{ whiteSpace: "nowrap" }}>60</td>
              <td>[Ds-PIM]</td>
              <td>
                변비 환자에서 강한 항콜린성 약제의 사용: 변비 악화 위험
                <ul>
                  <li>같은 적응증이 있으면서 항콜린성 작용이 약한 약물 고려</li>
                  <li>
                    치료가 필요한 경우 삼투성 하제[예, magnesium oxide, lactulose] 추가하고 식이요법
                    교육
                  </li>
                </ul>
                ※ 강한 항콜린성 약제 목록: 별도 첨부
              </td>
              <td>
                [GheOP'S]
                <br />
                [TIME]
                <br />
                [Korean2018]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr id="CCMM_Constipation_061">
              <td style={{ whiteSpace: "nowrap" }}>61</td>
              <td>[Ds-PIM]</td>
              <td>
                변비 환자에서 칼슘채널차단제: 변비 악화 위험
                <ul>
                  <li>고혈압 환자에서 변비 확인 시, 칼슘채널차단제 사용 재확인</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [ES-PIA]
                <br />
                [OPTI-SCRIPT criteria]
              </td>
            </tr>
            <tr id="CCMM_Constipation_062">
              <td style={{ whiteSpace: "nowrap" }}>62</td>
              <td>[Omission]</td>
              <td>
                변비 지속 상황일 경우 변비 유발 약물 사용 여부 확인. 가능하면 변비 부작용이 적은
                대체 약제로의 변경 고려
                <ul>
                  <li>
                    약물요법보다 비약물요법[예, 식이섬유 섭취, 운동] 우선 고려, 이후에도 변비 증상이
                    지속되는 경우 약물치료 권고
                  </li>
                  <li>
                    마약성 진통제 사용 환자에서는 팽창성 완하제[예, polycarbophil calcium, 차전자피
                    제제 등]는 부적절하므로, 다른 변비약[예, bisacodyl/docusate, lactulose]이용 권고
                  </li>
                </ul>
              </td>
              <td>
                [TIME]
                <br />
                [START]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>비뇨생식기 질환</td>
            </tr>
            <tr id="CCMM_Genitourinary_063">
              <td style={{ whiteSpace: "nowrap" }}>63</td>
              <td>[Ds-PIM]</td>
              <td>
                전립선비대증, 뇨저류 환자에서 강한 항콜린성 약제 사용: 뇨저류 악화 위험
                <ul>
                  <li>항콜린성 부작용 확인</li>
                  <li>부작용 정도를 평가하고, 필요시 다른 약으로의 대체 고려</li>
                </ul>
                ※ 강한 항콜린성 약제 목록: 별도 첨부
              </td>
              <td>
                [STOPP]
                <br />
                [TIME]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_Genitourinary_064">
              <td style={{ whiteSpace: "nowrap" }}>64</td>
              <td>[PIM]</td>
              <td>
                요실금, 절박뇨, 빈뇨 등 과활동성 방광 치료 목적의 oxybutynin 사용: 구갈, 변비,
                인지기능 저하 등 항콜린 부작용 위험 증가
                <ul>
                  <li>항콜린성 부작용 확인</li>
                </ul>
              </td>
              <td>
                [Korean2018]
                <br />
                [EU-PIM]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Genitourinary_065">
              <td style={{ whiteSpace: "nowrap" }}>65</td>
              <td>[Ds-PIM]</td>
              <td>
                요실금 환자에서 이뇨제 사용: 요실금 발생 증가 위험
                <ul>
                  <li>이뇨제 적응증 확인</li>
                  <li>
                    고혈압 치료 목적으로 사용하는 경우, 혈압 조절이 잘 되고 다른 약제를 사용할 수
                    있는 경우라면 이뇨제 대신 다른 계열의 항고혈압제로 변경
                  </li>
                </ul>
              </td>
              <td>
                [TIME]
                <br />
                [STOPP]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>불면증</td>
            </tr>
            <tr id="CCMM_Insomnia_066">
              <td style={{ whiteSpace: "nowrap" }}>66</td>
              <td>[PIM]</td>
              <td>
                수면진정제[예: z-drug, 벤조디아제핀]의 지속적 사용(30 일 이상 사용) 또는 매일 규칙적
                사용: 섬망, 치매, 인지장애 등 악화 위험
                <ul>
                  <li>비약물요법(예, 수면환경 개선 등) 및 점차 감량 권고, 간헐적 사용 추천</li>
                  <li>카페인 함유 제제 사용 확인 및 중단 권고</li>
                  <li>zolpidem 의 경우 노인 최대 용량 10 mg/day 로 권고됨</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Amsterdam]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Insomnia_067">
              <td style={{ whiteSpace: "nowrap" }}>67</td>
              <td>[PIM]</td>
              <td>
                수면유도제 목적의 일반의약품[예: doxylamine(아론정), diphenhydramine(슬리펠정) 등]
                사용: 항콜린 부작용 위험 증가 및 어지러움으로 낙상 위험 증가 가능
                <ul>
                  <li>비약물요법 [예, 수면환경 개선 등] 및 간헐적 사용 추천</li>
                  <li>2 주 이상 사용해도 증상 개선 없을 시 진료 추천</li>
                  <li>카페인 함유 제제 사용 확인 및 중단 권고</li>
                </ul>
              </td>
              <td>
                [PRISCUS]
                <br />
                [Korean2018]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_Insomnia_068">
              <td style={{ whiteSpace: "nowrap" }}>68</td>
              <td>[Ds-PIM]</td>
              <td>
                불면 환자에서 경구 비충혈제거제: 중추자극 효과로 인해 불면 악화[예: pseudoephedrine,
                phenylephrine 등]
                <ul>
                  <li>7 일 미만의 비강분무형 비충혈제거제로 변경 또는 고장성 생리식염수 사용</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [ES-PIA]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>인지기능 저하 또는 치매, 섬망 환자</td>
            </tr>
            <tr id="CCMM_Cognition_069">
              <td style={{ whiteSpace: "nowrap" }}>69</td>
              <td>[Ds-PIM]</td>
              <td>
                치매, 섬망, 인지기능 저하 환자에서 강한 항콜린성 약제의 사용: 치매, 섬망, 인지기능
                악화 가능
                <ul>
                  <li>같은 적응증이 있으면서 항콜린성 작용이 약한 약물로 변경 고려</li>
                </ul>
                ※ 강한 항콜린성 약제 목록: 별도 첨부
              </td>
              <td>
                [Beers]
                <br />
                [Amsterdam]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>기립성 저혈압</td>
            </tr>
            <tr id="CCMM_Orthostasis_070">
              <td style={{ whiteSpace: "nowrap" }}>70</td>
              <td>[Ds-PIM]</td>
              <td>
                실신 경험 및 서맥 환자에서 acetylcholine esterase 억제제 사용: 서맥, 실신 위험 증가
                <ul>
                  <li>사용이 필요한 경우 가능한 최소 용량으로 투여</li>
                  <li>맥박 수, 어지러움 확인</li>
                  <li>치매 치료제의 감량 및 변경[예, memantine] 권고</li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  ※ 참고: AchEI 외 치매 치료제로 memantine 이 있지만 memantine 의 경우 중등도에서
                  중증의 치매에 대해 급여 가능
                </span>
              </td>
              <td>
                [Beers]
                <br />
                [STOPP]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Orthostasis_071">
              <td style={{ whiteSpace: "nowrap" }}>71</td>
              <td>[Ds-PIM]</td>
              <td>
                기립성 저혈압 환자에서 비선택적 알파-1 차단제(doxazosin, prazosin, terazosin)
                사용: 기립성 저혈압, 낙상 위험 증가
                <ul>
                  <li>
                    피해야 할 비선택적 알파-1 차단제: 독사조신(doxazosin), 프라조신(prazosin),
                    테라조신(terazosin) — 노인에서 기립성 저혈압 위험이 높고 항고혈압제로 권고하지
                    않음.
                  </li>
                  <li>고혈압 치료 목적으로 사용할 경우에는 다른 항고혈압 약제로 변경</li>
                </ul>
              </td>
              <td>
                [Korean2018]
                <br />
                [RASP]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>파킨슨병 환자</td>
            </tr>
            <tr id="CCMM_Parkinsons_072">
              <td style={{ whiteSpace: "nowrap" }}>72</td>
              <td>[Ds-PIM]</td>
              <td>
                파킨슨병 환자에서 clozapine, quetiapine 이외의 항정신병 약제 사용: 파킨슨 증상 악화
                위험
                <ul>
                  <li>항정신병제 사용 필요 여부 확인</li>
                  <li>항정신병제 사용 필요 시 quetiapine 으로 변경 추천</li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  ※ 참고: Quetiapine 요양급여 기준(2018 년 1 월 31 일 고시): 허가사항 범위를
                  초과하여 '환시(Visual hallucination) 등의 정신과적(Psychiatric) 증상을 동반하는
                  파킨슨병 환자'에게 투약하는 경우에는 요양 급여를 인정함.
                </span>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr id="CCMM_Parkinsons_073">
              <td style={{ whiteSpace: "nowrap" }}>73</td>
              <td>[Ds-PIM]</td>
              <td>
                파킨슨병 환자에서 metoclopramide, clebopride 사용: 파킨슨 증상 악화 위험
                <ul>
                  <li>만성적 사용 필요성 확인(적응증 지속 또는 치료 중단의 지속)</li>
                  <li>비약물요법 추천</li>
                  <li>
                    항구토 치료 필요시 itopride 등 추천 (levosulpiride 는 파킨슨 증상 악화 위험
                    있음)
                  </li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>신경정신계 질환</td>
            </tr>
            <tr id="CCMM_Mentalhealth_074">
              <td style={{ whiteSpace: "nowrap" }}>74</td>
              <td>[PIM]</td>
              <td>
                Z-drug 을 포함한 수면제/진정제, 항우울제, 벤조디아제핀계 약물, 항정신병약 각 계열
                내에서 중복 처방: 낙상 위험 증가
                <ul>
                  <li>불필요한 중복의 경우 중단 권고</li>
                </ul>
              </td>
              <td>[RASP]</td>
            </tr>
            <tr id="CCMM_Mentalhealth_075">
              <td style={{ whiteSpace: "nowrap" }}>75</td>
              <td>[PIM]</td>
              <td>
                삼환계 항우울제 사용: 항콜린 특성으로 인해 구갈, 변비, 요저류, 인지기능 저하 등
                부작용 가능
                <ul>
                  <li>우울증 치료 목적 등으로 1 년 이상 사용 시 적응증 지속 여부 확인</li>
                  <li>
                    우울증 치료 목적으로 이용 시 SSRI [예외, paroxetine], SNRI, bupropion,
                    vortioxetine, agomelatine 등 추천 가능
                  </li>
                  <li>
                    신경병성 통증 목적 사용의 경우 SNRI, gabapentin, pregabalin, lidocaine 패치,
                    capsaicin 크림 등 추천 가능
                  </li>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [STOPP]
                <br />
                [Korean2018]
                <br />
                [TIME]
              </td>
            </tr>
            <tr id="CCMM_Mentalhealth_076">
              <td style={{ whiteSpace: "nowrap" }}>76</td>
              <td>[PIM]</td>
              <td>
                항우울제로 fluoxetine 사용: fluoxetine 의 경우 SSRI 약제 중 반감기가 길고
                약물상호작용 가능성이 높으며, 노인에서는 이상사례로 초조, 격앙(agitation) 및 수면
                장애가 빈번하게 나타남
                <ul>
                  <li>우울증 치료 목적으로 1 년 이상 사용한 경우 적응증 지속 여부 확인</li>
                  <li>식욕부진, 영양불량 환자에서 다른 SSRI 로 대체 추천</li>
                </ul>
              </td>
              <td>
                [TIME]
                <br />
                [PRISCUS]
                <br />
                [EU-PIM]
              </td>
            </tr>
            <tr id="CCMM_Mentalhealth_077">
              <td style={{ whiteSpace: "nowrap" }}>77</td>
              <td>[PIM]</td>
              <td>
                벤조디아제핀계 사용: 인지장애, 섬망, 어지러움, 낙상, 골절 등 위험 증가, 노인에서
                벤조디아제핀 감수성 증가
                <ul>
                  <li>
                    사용 적응증 평가: 경련, 근간대증, 벤조디아제핀 및 알코올 금단현상, 처치/수술
                    전후 진정 목적의 경우 적절한 적응증이므로 감량/중단 권고 불필요
                  </li>
                  <li>
                    중간 지속형 벤조디아제핀[예, alprazolam, bromazepam, etizolam, lorazepam] 또는
                    Z-약물[예, eszopiclon, zolpidem]을 일반 성인 상용량으로 사용하거나 30일 이상
                    연속 사용하는 경우:
                  </li>
                  <ul>
                    <li>
                      수면 목적으로 시작하는 시점 또는 불면이 조절 잘 되는 경우: 비약물요법으로의
                      전환 또는 성인 용량의 1/2 사용 권고
                    </li>
                    <li>불안 장애로 사용하고 있는 경우 비약물요법과 SSRI 로의 전환 고려</li>
                  </ul>
                  <li>
                    장시간 지속형 벤조디아제핀[예, clobazam, clonazepam, clorazepate, diazepam,
                    flunitrazepam, flurazepam, nitrazepam 등]
                  </li>
                  <ul>
                    <li>
                      수면 목적으로 시작하는 시점 또는 불면이 조절 잘 되는 경우: 비약물요법으로의
                      전환 또는 중간지속형 벤조디아제핀계 약물 또는 Z-drug 성인 용량의 1/2 용량으로
                      30일 미만 사용 권고
                    </li>
                    <li>
                      근이완 목적으로 사용시 물리치료 등의 비약물요법 고려, 비타민 B6 나 마그네슘
                      결핍 고려
                    </li>
                    <li>
                      중간지속형 벤조디아제핀계 약물 또는 Z-drug 로 변경하여 성인 용량의 1/2
                      용량으로 30일 미만 사용 권고
                    </li>
                  </ul>
                </ul>
              </td>
              <td>
                [Beers]
                <br />
                [STOPP]
                <br />
                [Korean2018]
              </td>
            </tr>
            <tr id="CCMM_Mentalhealth_078">
              <td style={{ whiteSpace: "nowrap" }}>78</td>
              <td>[DDI]</td>
              <td>
                Phenytoin 과 sulfamethoxazole/trimethoprim 병용: phenytoin 독성 증가
                <ul>
                  <li>Sulfamethoxazole/trimethoprim 중단 및 변경 고려</li>
                  <li>병용이 필요한 경우, phenytoin 혈중 농도 및 이상반응 모니터링</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [Beers]
                <br />
                [ES-PIA]
              </td>
            </tr>
            <tr id="CCMM_Mentalhealth_079">
              <td style={{ whiteSpace: "nowrap" }}>79</td>
              <td>[DDI]</td>
              <td>
                리튬을 ACEI/루프 이뇨제/NSAID 와 병용: 리튬 독성 증가
                <ul>
                  <li>병용 중단 및 변경 고려</li>
                  <li>병용이 필요한 경우, 리튬의 혈중 농도 및 이상반응 모니터링 필요</li>
                </ul>
              </td>
              <td>
                [GheOP'S]
                <br />
                [ES-PIA]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_Mentalhealth_080">
              <td style={{ whiteSpace: "nowrap" }}>80</td>
              <td>[DDI]</td>
              <td>
                NSAID 와 SSRI 병용: 출혈 위험 증가
                <ul>
                  <li>다른 진통제 이용 고려[예, acetaminophen]</li>
                  <li>적절한 소화성궤양용제[예, PPI] 사용 여부 확인</li>
                  <li>출혈 위험 및 증상 모니터링</li>
                </ul>
                <span style={{ fontSize: "0.9em", display: "block" }}>
                  참고: 근거가 확실하지는 않지만 일부 연구에서는 COX-2 선택적 억제제가 전통적 NSAIDs
                  보다 출혈 위험이 낮으며, SSRI 중에서도 paroxetine, sertraline, fluoxetine 이 다른
                  약제보다 출혈 위험이 더 큰 것으로 알려져 있음.
                </span>
              </td>
              <td>
                [GheOP'S]
                <br />
                [OPTI-SCRIPT criteria]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>폐쇄우각 녹내장</td>
            </tr>
            <tr id="CCMM_Glaucoma_081">
              <td style={{ whiteSpace: "nowrap" }}>81</td>
              <td>[Ds-PIM]</td>
              <td>
                폐쇄우각 녹내장 환자에서, 강한 항콜린성 약제의 사용: 녹내장 악화 위험
                <ul>
                  <li>중단 권고</li>
                </ul>
                ※ 강한 항콜린성 약제 목록: 별도 첨부
              </td>
              <td>
                [STOPP]
                <br />
                [Korean2018]
                <br />
                [Amsterdam]
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>노인 고혈압 목표</td>
            </tr>
            <tr id="CCMM_ElderlyBPTargets_082">
              <td style={{ whiteSpace: "nowrap" }}>82</td>
              <td></td>
              <td>
                노인 고혈압 환자에서 심뇌혈관질환 위험인자 및 무증상장기손상 평가 후 맞춤형 혈압 조절 목표 설정
                <ul>
                  <li>
                    위험인자 확인: 연령(남성 &gt;45세, 여성 &gt;55세), 조기 심뇌혈관질환의 가족력, 흡연, 비만, 이상지질혈증, 당뇨병
                  </li>
                  <li>
                    무증상장기손상 평가:
                    <ul>
                      <li>뇌 - 무증상 뇌경색, 백질병변</li>
                      <li>심장 - 좌심실비대</li>
                      <li>신장 - eGFR 저하</li>
                      <li>혈관 - 맥파속도 증가, 발목상완지수 감소</li>
                    </ul>
                  </li>
                  <li>지역사회 거주하는 65세 이상 건강한 노인에서 목표 혈압 &lt;140/90 mmHg 유지</li>
                  <li>무증상장기손상이나 심뇌혈관질환 위험인자를 동반한 당뇨병 환자에서는 목표 혈압 &lt;130/80 mmHg 유지</li>
                  <li>노쇠한 노인 또는 80세 이상 노인은 수축기 혈압 &lt;160 mmHg 목표로 약물치료 조절</li>
                  <li>정기적인 위험인자 재평가 및 혈압 모니터링 필요</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>노인 당뇨병 목표</td>
            </tr>
            <tr id="CCMM_ElderlyGlucoseTargets_083">
              <td style={{ whiteSpace: "nowrap" }}>83</td>
              <td></td>
              <td>
                노인 당뇨병 환자에서 건강상태와 노쇠정도를 고려한 혈당조절 목표 확인
                <ul>
                  <li>일반적 노인 환자에서 당화혈색소 7.5% 미만 목표</li>
                  <li>만성합병증이 적고 인지기능이 정상인 건강한 노인에서는 7.0-7.5%</li>
                  <li>다양한 만성질병 병존하거나 경증-중등도 인지기능 저하 또는 2개 이상 ADL 의존성 있는 환자는 8.0% 목표</li>
                  <li>
                    장기요양시설 거주자나 중등도-중증 인지기능 저하 또는 2개 이상 ADL 저하 환자는 당화혈색소보다 공복 혈당 100-180 mg/dL, 취침전 혈당 110-200 mg/dL 유지를 목표
                  </li>
                  <li>저혈당 여부 감시 필요</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>노인 고혈압 치료 가이드라인</td>
            </tr>
            <tr id="CCMM_ElderlyHTNTreatment_084">
              <td style={{ whiteSpace: "nowrap" }}>84</td>
              <td></td>
              <td>
                심부전을 동반한 노인 고혈압 환자에서 권장 약제 선택
                <ul>
                  <li>1차: ACE 억제제 또는 안지오텐신차단제</li>
                  <li>2차: Carvedilol, Metoprolol, Bisoprolol</li>
                  <li>3차: Hydrochlorothiazide (저용량)</li>
                  <li>4차: DHP 칼슘차단제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyHTNTreatment_085">
              <td style={{ whiteSpace: "nowrap" }}>85</td>
              <td></td>
              <td>
                당뇨병 또는 만성신질환을 동반한 노인 고혈압 환자에서 권장 약제 선택
                <ul>
                  <li>1차: ACE 억제제 또는 안지오텐신차단제</li>
                  <li>2차: DHP 칼슘차단제</li>
                  <li>3차: 이뇨제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyHTNTreatment_086">
              <td style={{ whiteSpace: "nowrap" }}>86</td>
              <td></td>
              <td>
                협심증 또는 심근경색을 동반한 노인 고혈압 환자에서 권장 약제 선택
                <ul>
                  <li>1차: Carvedilol, Metoprolol, Bisoprolol</li>
                  <li>2차: ACE 억제제 또는 안지오텐신차단제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyHTNTreatment_087">
              <td style={{ whiteSpace: "nowrap" }}>87</td>
              <td></td>
              <td>
                뇌졸중 기왕력이 있는 노인 고혈압 환자에서 권장 약제 선택
                <ul>
                  <li>1차: ACE 억제제 또는 안지오텐신차단제 + Hydrochlorothiazide 병용 또는 저용량 복합제</li>
                  <li>2차: DHP 칼슘차단제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyHTNTreatment_088">
              <td style={{ whiteSpace: "nowrap" }}>88</td>
              <td></td>
              <td>
                기타 노인 고혈압 환자에서 권장 약제 선택
                <ul>
                  <li>1차: DHP 칼슘차단제</li>
                  <li>2차: ACE 억제제 또는 안지오텐신차단제</li>
                  <li>3차: Thiazide계 이뇨제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>노인 당뇨병 치료 가이드라인</td>
            </tr>
            <tr id="CCMM_ElderlyDMTreatment_089">
              <td style={{ whiteSpace: "nowrap" }}>89</td>
              <td></td>
              <td>
                심부전, 만성신질환, 또는 죽상경화성 심혈관질환을 동반한 노인 당뇨병 환자에서 권장 약제 선택
                <ul>
                  <li>1차: SGLT2 억제제</li>
                  <li>2차: Metformin (만성신질환 제외)</li>
                  <li>3차: DPP4 억제제 (만성신질환의 경우)</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyDMTreatment_090">
              <td style={{ whiteSpace: "nowrap" }}>90</td>
              <td></td>
              <td>
                일반적인 노인 당뇨병 환자에서 권장 약제 선택
                <ul>
                  <li>1차: Metformin</li>
                  <li>2차: SGLT2 억제제</li>
                  <li>3차: DPP4 억제제</li>
                  <li>우선 선정하는 약제를 먼저 사용하고, 이후 필요시 다음 약제를 저용량부터 추가 권장</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr id="CCMM_ElderlyDMTreatment_091">
              <td style={{ whiteSpace: "nowrap" }}>91</td>
              <td></td>
              <td>
                탈수나 요로감염 위험이 있는 노인 당뇨병 환자에서 권장 약제 선택
                <ul>
                  <li>1차: DPP4 억제제</li>
                  <li>SGLT2 억제제는 탈수나 요로감염 위험이 있는 노인에서 피하는 것이 바람직함</li>
                  <li>주사제는 본 권고사항에서 추천에서 제외함</li>
                </ul>
              </td>
              <td>
              </td>
            </tr>
            <tr className="gray-header">
              <td colSpan={4}>SGLT2 억제제 및 RAS 억제제 적정사용</td>
            </tr>
            <tr id="CCMM_SGLT2andRAS_092">
              <td style={{ whiteSpace: "nowrap" }}>92</td>
              <td>[Omission]</td>
              <td>
                심부전 환자(HFrEF, HFmrEF, HFpEF)에서 SGLT2 억제제(다파글리플로진, 엠파글리플로진)
                사용 여부 확인
                <ul>
                  <li>
                    LVEF와 무관하게 심부전 입원 및 심혈관 사망 감소를 위해 권고. 시작 시 eGFR ≥20
                    mL/min/1.73 m² 필요
                  </li>
                  <li>
                    HFrEF에서는 RAS 억제제/ARNI, 베타차단제, MRA와 함께 GDMT 4제의 일부로 처방되었는지
                    확인
                  </li>
                  <li>
                    금기/주의 확인: 제1형 당뇨병, eGFR &lt;20 mL/min/1.73 m²(엠파글리플로진
                    EMPEROR-Reduced 제외 기준) 또는 &lt;30 mL/min/1.73 m²(다파글리플로진 DAPA-HF 제외
                    기준), 수축기 혈압 &lt;95~100 mmHg, 반복적 비뇨생식기 감염 병력
                  </li>
                  <li>
                    환자가 임의로 중단하지 않았는지 확인하고, 미사용 사유를 확인 후 사용 권고
                  </li>
                </ul>
              </td>
              <td>
                [ACC/AHA2022]
                <br />
                [ESC2023]
              </td>
            </tr>
            <tr id="CCMM_SGLT2andRAS_093">
              <td style={{ whiteSpace: "nowrap" }}>93</td>
              <td>[Ds-PIM]</td>
              <td>
                신기능 저하 환자에서 SGLT2 억제제(다파글리플로진, 엠파글리플로진, 카나글리플로진,
                에르투글리플로진) 사용 적절성 확인
                <ul>
                  <li>
                    eGFR이 처방 적응증에 맞는 시작 한계 이상인지 확인 — 신규 시작은 eGFR ≥20
                    mL/min/1.73 m² 권고. eGFR &lt;20에서 신규 시작 회피
                  </li>
                  <li>
                    시작 후 eGFR이 20 mL/min/1.73 m² 미만으로 감소한 경우: 약물 불내성 또는
                    신대체요법(KRT) 시작 전까지는 지속 사용 가능. eGFR 감소만으로 자동 중단하지 않음
                  </li>
                </ul>
              </td>
              <td>
                [KDIGO2024]
                <br />
                [Beers]
              </td>
            </tr>
            <tr id="CCMM_SGLT2andRAS_094">
              <td style={{ whiteSpace: "nowrap" }}>94</td>
              <td>[Omission]</td>
              <td>
                단백뇨 동반 만성신질환 환자에서 RAS 억제제(ACE 억제제 또는 ARB) 사용 여부 확인
                <ul>
                  <li>
                    제2형 당뇨병 + 만성신질환 + 중등도-중증 알부민뇨(A2~A3, ACR ≥30 mg/g): RAS 억제제
                    사용 권고.
                  </li>
                  <li>
                    비당뇨 만성신질환 + 중증 알부민뇨(A3, ACR ≥300 mg/g): RAS 억제제 사용 권고
                  </li>
                  <li>
                    eGFR이 30 mL/min/1.73 m² 미만으로 감소하더라도 ACE 억제제 또는 ARB는 지속 사용 가능
                    (단, 증상성 저혈압 또는 조절되지 않는 고칼륨혈증 시 용량 감량 또는 중단 고려)
                  </li>
                  <li>
                    RAS 억제제 시작 또는 증량 후 2~4주 이내 혈압, 혈청 크레아티닌, 혈청 칼륨 확인. 시작
                    후 4주 이내 혈청 크레아티닌이 30% 이상 상승하지 않는 한 RAS 억제제 지속
                  </li>
                </ul>
              </td>
              <td>
                [KDIGO2024]
                <br />
                [Korean2018]
              </td>
            </tr>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default CCMM;
